import moment from 'moment'

import config from '../config/app'

export const formatDateTime = (date) => {
    const parsedDate = moment(date?.iso || date);

    if (!parsedDate.isValid()) {
        return "-";
    }

    return parsedDate.format(config.dateFormat);
};


export const formatDate = date => {
    return formatDateTime(date).substring(0, 10)
}

export const getRelativeTimeFromNow = (date) => {
  const parsed = moment(date);
  if (!parsed.isValid()) return "-";

  const daysAgo = moment().diff(parsed, "days");
  const hoursAgo = moment().diff(parsed, "hours");

  return daysAgo === 0 ? `${hoursAgo} hours ago` : `${daysAgo} days ago`;
};